import { useTranslations } from "next-intl";

import { PanelToolbar } from "@/components/sidebar/PanelToolbar";

import { BlockquoteButton } from "./BlockquoteButton";
import { CalloutButton } from "./CalloutButton";
import { ChecklistButton } from "./ChecklistButton";
import { ListFormatDropdown } from "./ListFormatDropdown";
import { TextHeadingDropdown } from "./TextHeadingDropdown";

import type { DocumentModel } from "@/models/DocumentModel";

type Props = {
  doc: DocumentModel;
  isCollapsed?: boolean;
  // Images can only be wrapped in callout/quote; list items require a leading paragraph
  wrapOnly?: boolean;
};

export function BlockFormatStyle({ doc, isCollapsed, wrapOnly }: Props) {
  const t = useTranslations("sidebar");

  return (
    <PanelToolbar
      label={t("toolbars.blockFormat")}
      isCollapsed={isCollapsed}
      className={isCollapsed ? "gap-1" : "flex-1 justify-between"}
    >
      <TextHeadingDropdown doc={doc} isCollapsed={isCollapsed} disabled={wrapOnly} />
      <ListFormatDropdown doc={doc} isCollapsed={isCollapsed} disabled={wrapOnly} />
      <ChecklistButton doc={doc} isCollapsed={isCollapsed} disabled={wrapOnly} />
      <CalloutButton doc={doc} isCollapsed={isCollapsed} />
      <BlockquoteButton doc={doc} isCollapsed={isCollapsed} />
    </PanelToolbar>
  );
}
